import React, { useState, useEffect } from "react";
import './Licenses.css';

const Licenses = () => {
  const [licenses, setLicenses] = useState([]);

  useEffect(() => {
    // Fetching licenses data
    fetch("https://api.spadserver.com/api/product/Licenses")
      .then((response) => response.json())
      .then((data) => setLicenses(data.data.products))
      .catch((error) => console.error("Error fetching licenses data:", error));
  }, []);

  // Function to strip HTML tags from the description
  const stripHtmlTags = (str) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
  };

  return (
    <div className="container text-white mb-10">
      <h1 className="text-2xl font-bold mb-10">لایسنس‌های هاستینگ و سرور</h1>
      <div className="flex justify-center mb-20">
        تیم اسپاد سرور جهت حمایت از کسب و کارهای نوپا و به حداقل رساندن هزینه‌ها اقدام به ارائه لایسنس‌هایی با هزینه‌ی مناسب نموده است.
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {licenses.map((license, index) => {
          // Construct the image URL or use a fallback
          const imageUrl = license.image_path 
            ? `https://api.spadserver.com/${license.image_path}` 
            : "/images/domain-registration.png"; // Ensure the fallback image path is correct

          return (
            <div key={index} className="card-container">
              <div className="licenses-content">
                <div className="image-title-container">
                  <img
                    className="licenses-image"
                    src={imageUrl}
                    alt={license.title}
                  />
                </div>
                <h2 className="licenses-text text-xl font-semibold flex justify-center mt-8 text-[11px]">
                  {license.title}
                </h2>
                <div className="flex justify-center annually text-[9px]">(ماهانه)</div>
                <div className="bottom-content flex justify-between">
                  <p className="mt-2 font-bold text-sm">
                    {license.monthly} {license.currency.suffix}
                  </p>
                  <a
                    href={license.slug}
                    className="purchase-button mr-10"
                  >
                    خرید لایسنس
                  </a>
                </div>
              </div>
              <div className="licenses-description">
                <p className="text-[10px]">{stripHtmlTags(license.desc)}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="textSiteDesign text-white flex flex-col items-center justify-center p-4">
        <p className="text-center mt-10 text-xl font-bold">طراحی سایت</p>
        <div className="text-md mt-8 mb-8 px-4 sm:mt-10 sm:mb-10 sm:px-6 md:mt-12 md:mb-12 md:px-8 lg:mt-14 lg:mb-14 lg:px-10 xl:mt-16 xl:mb-16 xl:px-12 text-justify text-sm">
          <p>
            با خدمات طراحی سایت اسپاد سرور، کسب‌وکار آنلاین خود را به سطح جدیدی
            ببرید. ما با استفاده از آخرین تکنولوژی‌ها و طراحی‌های مدرن، وب‌سایتی
            منحصربه‌فرد و حرفه‌ای برای شما ایجاد می‌کنیم.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 mt-4">
          <div className="backgroundVector rounded-full p-2 flex justify-center items-center">
            <img className="w-7" src="/images/w.png" alt="Icon 1" />
          </div>
          <div className="backgroundVector rounded-full p-2 flex justify-center items-center">
            <img className="w-7" src="/images/web-hosting.png" alt="Icon 2" />
          </div>
          <div className="backgroundVector rounded-full p-2 flex justify-center items-center">
            <img className="w-7" src="/images/program.png" alt="Icon 3" />
          </div>
        </div>
        <button className="bg-red-400 p-3 w-40 rounded-[30px] mt-10 request">
          ارسال درخواست
        </button>
      </div>
    </div>
  );
};

export default Licenses;
